export enum AuthTabType {
    NONE = "none",
    LOGIN = "login",
    REGISTRATION = "registration",
    REMIND_PASSWORD = "remind_password",
    REMIND_PASSWORD_CONFIRMATION = "remind_password_confirmation"
}
export enum AuthTabType {
    NONE = "none",
    LOGIN = "login",
    REGISTRATION = "registration",
    REMIND_PASSWORD = "remind_password",
    REMIND_PASSWORD_CONFIRMATION = "remind_password_confirmation"
}
